/// <amd-module name="Feed/Legacy/Components/Metric" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";

import { getFriendlyDisplayValue } from "VSSUI/Utilities/FriendlyNumber";
import { VssIcon, VssIconType, IVssIconProps } from "VSSUI/VssIcon";

import { PackageMetrics, PackageVersionMetrics } from "Feed/Common/Contracts/Feed";
import { MetricType } from "Feed/Common/Types/MetricType";

export interface IResourceStringPair {
    singular: string;
    plural: string;
}

export interface IMetricProps {
    metrics: PackageMetrics | PackageVersionMetrics;
    metricType: MetricType;
    className?: string;
    resourceStrings?: IResourceStringPair;
}

export const Metrics: React.StatelessComponent<IMetricProps> = (props: IMetricProps) => {
    const metricValue = getMetricValue(props.metrics, props.metricType);
    const displayString = getDisplayString(props.resourceStrings, metricValue);

    return metricValue == null ? null : (
        <div className={props.className}>
            {renderIcon(VssIconType.fabric, getMetricIcon(props.metricType))}
            <span className="aggregated-metric-text">{displayString}</span>
        </div>
    );

    function getMetricValue(metrics: PackageMetrics | PackageVersionMetrics, metricType: MetricType): number {
        if (metrics == null) {
            return;
        }

        switch (metricType) {
            case MetricType.DownloadCount:
                return metrics.downloadCount || 0;
            case MetricType.UniqueUsers:
                return metrics.downloadUniqueUsers || 0;
            default:
                return 0;
        }
    }

    function getMetricIcon(metricType: MetricType): string {
        switch (metricType) {
            case MetricType.DownloadCount:
                return "Download";
            case MetricType.UniqueUsers:
                return "People";
            default:
                return "";
        }
    }

    function renderIcon(iconType: VssIconType, iconName: string): JSX.Element {
        if (iconName !== "") {
            const iconProps = { iconType, iconName } as IVssIconProps;
            return <VssIcon {...iconProps} className={"aggregated-metric-icon"} />;
        }
    }

    function getDisplayString(resourceStrings: IResourceStringPair, metricValue: number): string {
        if (metricValue == null) {
            return null;
        } else if (resourceStrings == null) {
            return getFriendlyDisplayValue(metricValue);
        } else if (metricValue === 1) {
            return Utils_String.format(resourceStrings.singular, getFriendlyDisplayValue(metricValue));
        } else {
            return Utils_String.format(resourceStrings.plural, getFriendlyDisplayValue(metricValue));
        }
    }
};
